import script from "./EditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditModal.vue?vue&type=script&setup=true&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=6362bbed&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6362bbed"]])

export default __exports__